var React = require('react');

function Microscope (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M104 384h208a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H104a8 8 0 0 1-8-8v-16a8 8 0 0 1 8-8z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M464 448h-1.29A191 191 0 0 0 512 320c0-105.88-86.12-192-192-192v64a128 128 0 0 1 0 256H48a48 48 0 0 0-48 48 16 16 0 0 0 16 16h480a16 16 0 0 0 16-16 48 48 0 0 0-48-48zM160 320h12v16a16 16 0 0 0 16 16h40a16 16 0 0 0 16-16v-16h12a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32V16a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v16a32 32 0 0 0-32 32v224a32 32 0 0 0 32 32z","className":"fa-primary","key":2})]);
}

Microscope.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Microscope;

Microscope.default = Microscope;
